import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { IconButton, Box } from "@mui/material";
import ClearAllIcon from '@mui/icons-material/ClearAll';
import AlarmRow from "./AlarmRow";
import { Alarms } from "../../../../actions/apiActions";
import { useSystemConfig, useSystemId } from "../../../../hooks/useReduxSelectors";
import { getAllDeviceAlarmsHistory } from "../../../../ducks/alarmsHistoryDuck";

const headerSpanSx = {
  display: "inline-block",
  flex: 1,
  minWidth: 0,
  justifyContent: "center",
  alignSelf: "center",
  textAlign: "center",
  letterSpacing: "1px",
  fontSize: "18px",
};

const HistoryTable = ({ alarmsList }) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const systemId = useSystemId();
  const config = useSystemConfig();

  const clearAllAlarms = async () => {
    const payload = {
      siteId: (config && config.CUSTOMER_ID) || "",
      edgeUnitId: (config && config.DEVICE_ID) || ""
    };
    const baseUrl = config.DATA_URL;
    try {
      const response = await Alarms.clearAllAlarms(baseUrl, payload);
      console.log("Clear all alarms response:", response);
      if (response.status === 200) {
        console.log("All alarms cleared successfully");
        dispatch(getAllDeviceAlarmsHistory(systemId));
      } else {
        console.error("Failed to clear all alarms:", response);
      }
    } catch (error) {
      console.error("Error clearing all alarms:", error);
    }
  };

  return (
    <Box>
      <Box>
        <Box sx={{ bgcolor: "background.light", borderRadius: 1, mb: 0.25, py: 0.5 }}>
          <Box sx={{ display: "flex", justifyContent: "stretch" }}>
            <Box sx={{ ...headerSpanSx, flex: 1.5 }}>Name</Box>
            <Box sx={headerSpanSx}>{t("Active")}</Box>
            <Box sx={headerSpanSx}>{t("Alarm Name")}</Box>
            <Box sx={headerSpanSx}>{t("Triggered")}</Box>
            <Box sx={headerSpanSx}>{t("Turned Off")}</Box>
            <Box sx={{ ...headerSpanSx, display: "flex", justifyContent: "center" }}>
              <IconButton
                variant="outlined"
                size="small"
                onClick={clearAllAlarms}
                title="Clear All Alarms"
                color="error"
              >
                <ClearAllIcon />
              </IconButton>
            </Box>
            <Box sx={headerSpanSx}></Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ mt: "5px" }}>
        {alarmsList &&
          alarmsList.length > 0 &&
          alarmsList.map((alarm, index) => (
            <AlarmRow key={alarm.triggerTimeStamp + "_" + index} alarm={alarm} />
          ))}
        {(!alarmsList || (alarmsList && alarmsList.length === 0)) && (
          <Box sx={{ bgcolor: "background.light", borderRadius: 1, mb: 0.25, py: 0.5 }}>
            <Box sx={{ display: "flex", justifyContent: "stretch" }}>
              <Box sx={{ textAlign: "center", width: "100%", display: "block", flex: 1 }}>No Alarms</Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default HistoryTable;
